module.exports = __webpack_public_path__ + "static/media/2DGACM13.1a2cbece.jpg";